<template>
  <div class="row">
    <div class="d-flex flex-column gap-1 align-items-center justify-content-center bg-white" style="height: 200px;">

      <!-- Default Logo -->
      <img :src="`${siteURL}assets/img/logo.png`" alt="لوگو نفتکش بار اصفهان" width="80px" />
      <!-- Default Logo -->

      <h1 class="fs-4 m-0 fw-bold"> {{ basicSiteInfos?.companyName || "شرکت حمل و نقل فراورده های نفتی" }}</h1>
      <p class="fs-5 m-0 fw-normal">شرکت حمل و نقل مواد نفتی و پتروشیمی</p>
    </div>
  </div>
  <p class="fs-4 mt-0 mt-4 me-3 fw-bold">اطلاعیه ها</p>
  <div class="notice mt-3 mx-2">
    <div class="card shadow-none mb-3 py-2 rounded-4" v-for="notice in noticeStore.activeNoticeData" :key="notice.id">
      <div class="card-header px-3 py-0">
        <div class="text-end pt-1">
          <h6 class="fw-normal text-info mb-0 text-capitalize">
            <i class="bi bi-info-circle-fill text-info"></i>
            {{ notice?.title }}
          </h6>
        </div>
      </div>
      <!-- <hr class="dark horizontal my-0" /> -->
      <div class="card-body m-0 px-3 py-1">
        <p class="m-0 text-dark">
          {{ notice?.text }}
        </p>
      </div>
      <!-- <div class="card-footer p-3">
        <p class="mb-0 text-start text-info">{{ formatDate(notice?.created_at) }}</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { usePublicNoticeStore } from "@/store/adminStore";
import { onMounted } from "vue";
import moment from "moment-jalaali";
import { siteURL } from "@/http/api"

export default {
  props: {
    basicSiteInfos: {
      type: Object,
      required: true
    },
    companyLogoName: {
      type: String
    }
  },
  setup() {
    const noticeStore = usePublicNoticeStore();
    onMounted(async () => {
      noticeStore.getActiveNotice();
    });
    const formatDate = (dateString) => {
      return moment(dateString).locale("fa").format("jYYYY/jM/jD"); // Convert to Persian date format
    };
    return {
      noticeStore,
      formatDate,
      siteURL
    };
  },
};
</script>

<style></style>
